import {useEffect, useState} from "react"
import {RepoMeta} from "../interfaces/repos"
import {ProfileDB} from "../models/ProfileDB.model"

export function useRepoList(profile?: ProfileDB) {
  const [repos, setRepos] = useState<RepoMeta[]>([])

  useEffect(() => {
    if (!profile) {
      return
    }
    const repos: RepoMeta[] = Object.keys(profile.all)
      .filter(key => key.startsWith("repo_"))
      .map(key => profile.get(key as `repo_${string}`))
      .filter(repo => repo.id != null)
      .sort((a, b) => {
        return b.createAt - a.createAt
      })
    setRepos(repos)
  }, [profile])

  return {
    repos
  }
}
